/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grassy_Best_Penguin_OfferInputs */

const fr_grassy_best_penguin_offer = /** @type {(inputs: Grassy_Best_Penguin_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editer un programme / Cours`)
};

/**

* @param {Grassy_Best_Penguin_OfferInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const grassy_best_penguin_offer = /** @type {((inputs?: Grassy_Best_Penguin_OfferInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grassy_Best_Penguin_OfferInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_grassy_best_penguin_offer(inputs)
});